export const SITE_URL = 'https://domidoor.ro';

// Per-page SEO titles & descriptions (5 languages). RO targets local
// commercial keywords: serviciu + Timișoara/Timiș, brand names, preț/ofertă.
export const SEO = {
  home: {
    path: '/',
    ro: {
      title: 'Domidoor — Termopane, Uși de Garaj, Rulouri | Timiș',
      desc: 'Termopane, uși de garaj, rulouri și automatizări cu montaj inclus în Timișoara și Timiș. Prețuri de producător, garanție 10 ani. Cere ofertă!',
    },
    en: {
      title: 'Domidoor Solutions — PVC Windows, Garage Doors, Automation | Timiș',
      desc: 'Salamander PVC windows and doors, sectional garage doors and gate automation in Cenad, Timișoara and surroundings. Professional installation, 10-year warranty. Free quote!',
    },
    de: {
      title: 'Domidoor Solutions — PVC-Fenster, Garagentore, Automatisierung | Timiș',
      desc: 'Salamander PVC-Fenster und -Türen, Sektionaltore und Torautomatisierung in Cenad, Timișoara und Umgebung. Professionelle Montage, 10 Jahre Garantie. Kostenloses Angebot!',
    },
    es: {
      title: 'Domidoor Solutions — Ventanas PVC, Puertas de Garaje, Automatización | Timiș',
      desc: 'Ventanas y puertas PVC Salamander, puertas seccionales de garaje y automatización de portones en Cenad, Timișoara y alrededores. Montaje profesional, 10 años de garantía. ¡Presupuesto gratis!',
    },
    it: {
      title: 'Domidoor Solutions — Infissi PVC, Porte da Garage, Automazione | Timiș',
      desc: 'Finestre e porte in PVC Salamander, portoni sezionali e automazione cancelli a Cenad, Timișoara e dintorni. Montaggio professionale, garanzia 10 anni. Preventivo gratuito!',
    },
  },
  pvc: {
    path: '/tamplarie-pvc',
    ro: {
      title: 'Termopane Timișoara cu Montaj Inclus | Domidoor',
      desc: 'Termopane Salamander, VEKA, Aluplast cu montaj inclus în Timișoara și Timiș. 5–7 camere, triplu geam, preț de producător. Ofertă gratuită!',
    },
    en: {
      title: 'PVC Windows & Doors Timișoara — Salamander Profiles | Domidoor',
      desc: 'Salamander PVC joinery in Timișoara and Timiș county: 5–7 chamber windows, triple glazing, PVC doors, sliding systems. MACO/ROTO hardware. Free quote!',
    },
    de: {
      title: 'PVC-Fenster & Türen Timișoara — Salamander Profile | Domidoor',
      desc: 'Salamander PVC-Fenster in Timișoara und Kreis Timiș: 5–7 Kammern, Dreifachverglasung, PVC-Türen, Schiebesysteme. MACO/ROTO-Beschläge. Kostenloses Angebot!',
    },
    es: {
      title: 'Ventanas PVC Timișoara — Perfiles Salamander | Domidoor',
      desc: 'Carpintería PVC Salamander en Timișoara y condado de Timiș: ventanas de 5–7 cámaras, triple acristalamiento, puertas PVC, correderas. Herrajes MACO/ROTO. ¡Presupuesto gratis!',
    },
    it: {
      title: 'Infissi PVC Timișoara — Profili Salamander | Domidoor',
      desc: 'Serramenti PVC Salamander a Timișoara e provincia di Timiș: finestre 5–7 camere, triplo vetro, porte PVC, scorrevoli. Ferramenta MACO/ROTO. Preventivo gratuito!',
    },
  },
  rulouri: {
    path: '/rulouri',
    ro: {
      title: 'Rulouri Exterioare Timișoara — Aluminiu, Somfy | Domidoor',
      desc: 'Rulouri exterioare din aluminiu în Timișoara și Timiș: sisteme SK, SP-E, SKT, SDZ, motoare Somfy, culori RAL. Măsurători gratuite!',
    },
    en: {
      title: 'Exterior Roller Shutters Timișoara — Aluminium Systems | Domidoor',
      desc: 'Aluminium exterior shutters in Timișoara and Timiș county: SK top-mounted, SP-E built-in, SKT adaptive, SDZ renovation systems. Somfy motors, RAL colours. Free quote!',
    },
    de: {
      title: 'Außenrollläden Timișoara — Aluminium-Systeme | Domidoor',
      desc: 'Aluminium-Außenrollläden in Timișoara und Kreis Timiș: Vorsatz SK, Unterputz SP-E, Aufsatz SKT, Sanierung SDZ. Somfy-Motoren, RAL-Farben. Kostenloses Angebot!',
    },
    es: {
      title: 'Persianas Exteriores Timișoara — Sistemas de Aluminio | Domidoor',
      desc: 'Persianas exteriores de aluminio en Timișoara y provincia de Timiș: sistemas SK, SP-E, SKT, SDZ. Motores Somfy, colores RAL. ¡Presupuesto gratis!',
    },
    it: {
      title: 'Avvolgibili Esterne Timișoara — Sistemi in Alluminio | Domidoor',
      desc: 'Avvolgibili esterne in alluminio a Timișoara e provincia di Timiș: sistemi SK, SP-E a scomparsa, SKT, SDZ. Motori Somfy, colori RAL. Preventivo gratuito!',
    },
  },

  garaj: {
    path: '/porti-de-garaj',
    ro: {
      title: 'Uși de Garaj Timișoara — Porți Secționale | Domidoor',
      desc: 'Uși de garaj secționale 42 mm (porți de garaj) în Timișoara și Timiș, cu ușă pietonală. Orice culoare RAL, garanție 10 ani. Cere preț!',
    },
    en: {
      title: 'Garage Doors Timișoara — Sectional, Roller, Industrial | Domidoor',
      desc: '42 mm sectional garage doors, roller and industrial doors in Timișoara and Timiș. SINGLE, MULTI, FLAT, BLOCKS, MULTI RIB panels, any RAL colour. 10-year warranty.',
    },
    de: {
      title: 'Garagentore Timișoara — Sektional-, Roll-, Industrietore | Domidoor',
      desc: '42-mm-Sektionaltore, Rolltore und Industrietore in Timișoara und Timiș. SINGLE, MULTI, FLAT, BLOCKS, MULTI RIB Paneele, jede RAL-Farbe. 10 Jahre Garantie.',
    },
    es: {
      title: 'Puertas de Garaje Timișoara — Seccionales, Enrollables | Domidoor',
      desc: 'Puertas seccionales de 42 mm, enrollables e industriales en Timișoara y Timiș. Paneles SINGLE, MULTI, FLAT, BLOCKS, MULTI RIB, cualquier color RAL. 10 años de garantía.',
    },
    it: {
      title: 'Porte da Garage Timișoara — Sezionali, Avvolgibili | Domidoor',
      desc: 'Portoni sezionali da 42 mm, avvolgibili e industriali a Timișoara e Timiș. Pannelli SINGLE, MULTI, FLAT, BLOCKS, MULTI RIB, qualsiasi colore RAL. Garanzia 10 anni.',
    },
  },
  auto: {
    path: '/automatizari',
    ro: {
      title: 'Automatizări Porți Timișoara — Motoare BFT | Domidoor',
      desc: 'Automatizări porți batante și culisante în Timișoara și Timiș — motoare BFT, Nice, Somfy, control din telefon. Montaj și service autorizat.',
    },
    en: {
      title: 'Gate Automation Timișoara — BFT, Nice, Somfy Motors | Domidoor',
      desc: 'Automation for swing and sliding gates, garage door motors in Timișoara and Timiș. BFT, Nice, Somfy with remote and phone control. Authorised installation and service.',
    },
    de: {
      title: 'Torautomatisierung Timișoara — BFT, Nice, Somfy | Domidoor',
      desc: 'Automatisierung für Dreh- und Schiebetore, Garagentorantriebe in Timișoara und Timiș. BFT, Nice, Somfy mit Handsender und App-Steuerung. Autorisierter Service.',
    },
    es: {
      title: 'Automatización de Portones Timișoara — BFT, Nice, Somfy | Domidoor',
      desc: 'Automatización para puertas batientes y correderas, motores para garaje en Timișoara y Timiș. BFT, Nice, Somfy con mando y control por teléfono. Servicio autorizado.',
    },
    it: {
      title: 'Automazione Cancelli Timișoara — BFT, Nice, Somfy | Domidoor',
      desc: 'Automazione per cancelli battenti e scorrevoli, motori per porte da garage a Timișoara e Timiș. BFT, Nice, Somfy con telecomando e controllo da telefono. Servizio autorizzato.',
    },
  },
  portofoliu: {
    path: '/portofoliu',
    ro: {
      title: 'Portofoliu Domidoor — Tâmplărie PVC, Uși Garaj | Timiș',
      desc: 'Galerie cu lucrările Domidoor Solutions: ferestre PVC, porți de garaj secționale și automatizări montate în Timișoara, Cenad, Jimbolia, Arad și împrejurimi.',
    },
    en: {
      title: 'Our Work — PVC Joinery, Garage Doors | Domidoor',
      desc: 'Gallery of Domidoor Solutions projects: PVC windows, sectional garage doors and automation installed in Timișoara, Cenad, Jimbolia, Arad and surroundings.',
    },
    de: {
      title: 'Projekte — PVC-Fenster, Garagentore | Domidoor',
      desc: 'Galerie der Domidoor Solutions Projekte: PVC-Fenster, Sektionaltore und Automatisierung in Timișoara, Cenad, Jimbolia, Arad und Umgebung.',
    },
    es: {
      title: 'Proyectos — Carpintería PVC, Puertas de Garaje | Domidoor',
      desc: 'Galería de proyectos Domidoor Solutions: ventanas PVC, puertas seccionales y automatización en Timișoara, Cenad, Jimbolia, Arad y alrededores.',
    },
    it: {
      title: 'Progetti — Infissi PVC, Porte da Garage | Domidoor',
      desc: 'Galleria dei progetti Domidoor Solutions: finestre PVC, portoni sezionali e automazione a Timișoara, Cenad, Jimbolia, Arad e dintorni.',
    },
  },
  contact: {
    path: '/contact',
    ro: {
      title: 'Contact Domidoor — Termopane, Uși de Garaj | Cenad',
      desc: 'Cere ofertă gratuită pentru termopane, uși de garaj sau automatizări. Sună la 0766 330 933 sau vino în Cenad, Str. Principală 1544, jud. Timiș.',
    },
    en: {
      title: 'Contact Domidoor Solutions — PVC & Garage Doors Timiș | Free Quote',
      desc: 'Request a free quote for PVC joinery, garage doors or automation. Call +40 766 330 933 or visit us in Cenad, Strada Principală 1544, Timiș county. Mon–Fri 09:00–17:30.',
    },
    de: {
      title: 'Kontakt Domidoor Solutions — PVC & Garagentore Timiș | Angebot',
      desc: 'Kostenloses Angebot für PVC-Fenster, Garagentore oder Automatisierung. Rufen Sie +40 766 330 933 an oder besuchen Sie uns in Cenad, Strada Principală 1544, Kreis Timiș. Mo–Fr 09:00–17:30.',
    },
    es: {
      title: 'Contacto Domidoor Solutions — PVC y Garaje Timiș | Presupuesto',
      desc: 'Pida presupuesto gratuito para carpintería PVC, puertas de garaje o automatización. Llame al +40 766 330 933 o visítenos en Cenad, Strada Principală 1544, Timiș. Lun–Vie 09:00–17:30.',
    },
    it: {
      title: 'Contatti Domidoor Solutions — PVC e Garage Timiș | Preventivo',
      desc: 'Richiedi un preventivo gratuito per infissi PVC, porte da garage o automazione. Chiama +40 766 330 933 o vieni a Cenad, Strada Principală 1544, Timiș. Lun–Ven 09:00–17:30.',
    },
  },
  configurator: {
    path: '/configurator',
    ro: {
      title: 'Configurator Uși de Garaj — Preț Online | Domidoor',
      desc: 'Măsoară garajul în 6 pași simpli, alege modelul panoului și culoarea, și primești ofertă exactă pentru poarta de garaj. Configurator online gratuit.',
    },
    en: {
      title: 'Garage Door Configurator — Measure & Get a Price | Domidoor',
      desc: 'Measure your garage in 6 simple steps, choose the panel model and colour, and get an exact quote for your garage door. Free online configurator.',
    },
    de: {
      title: 'Garagentor-Konfigurator — Maße & Preis | Domidoor',
      desc: 'Vermessen Sie Ihre Garage in 6 einfachen Schritten, wählen Sie Paneelmodell und Farbe und erhalten Sie ein genaues Angebot. Kostenloser Online-Konfigurator.',
    },
    es: {
      title: 'Configurador Puertas de Garaje — Mida y Pida Precio | Domidoor',
      desc: 'Mida su garaje en 6 pasos sencillos, elija el modelo de panel y el color, y reciba un presupuesto exacto. Configurador online gratuito.',
    },
    it: {
      title: 'Configuratore Porte da Garage — Misura e Prezzo | Domidoor',
      desc: 'Misura il tuo garage in 6 semplici passi, scegli modello del pannello e colore, e ricevi un preventivo preciso. Configuratore online gratuito.',
    },
  },
  legal: {
    path: '/politica-cookies',
    noindex: true,
    ro: { title: 'Domidoor Solutions — Legal', desc: 'Informații legale Domidoor Solutions.' },
  },
  garajTimisoara: {
    path: '/porti-de-garaj-timisoara',
    ro: {
      title: 'Uși de Garaj Timișoara — Montaj Porți Secționale | Domidoor',
      desc: 'Montaj uși de garaj secționale (porți) în Timișoara, Ghiroda, Giroc, Dumbrăvița. Măsurători gratuite, garanție 10 ani. Tel: 0766 330 933.',
    },
    en: {
      title: 'Garage Doors Timișoara — Sectional & Roller Installation | Domidoor',
      desc: 'Sectional and roller garage door installation in Timișoara, Ghiroda, Giroc, Dumbrăvița. Free measuring, one-day installation, 10-year warranty. Call +40 766 330 933.',
    },
    de: {
      title: 'Garagentore Timișoara — Sektional- & Rolltor-Montage | Domidoor',
      desc: 'Montage von Sektional- und Rolltoren in Timișoara, Ghiroda, Giroc, Dumbrăvița. Kostenloses Aufmaß, Montage an einem Tag, 10 Jahre Garantie. +40 766 330 933.',
    },
    es: {
      title: 'Puertas de Garaje Timișoara — Montaje Seccionales | Domidoor',
      desc: 'Montaje de puertas seccionales y enrollables en Timișoara, Ghiroda, Giroc, Dumbrăvița. Medición gratuita, montaje en un día, 10 años de garantía. +40 766 330 933.',
    },
    it: {
      title: 'Porte da Garage Timișoara — Montaggio Sezionali | Domidoor',
      desc: 'Montaggio portoni sezionali e avvolgibili a Timișoara, Ghiroda, Giroc, Dumbrăvița. Rilievo gratuito, montaggio in un giorno, garanzia 10 anni. +40 766 330 933.',
    },
  },
  pvcTimisoara: {
    path: '/tamplarie-pvc-timisoara',
    ro: {
      title: 'Termopane Timișoara cu Montaj Inclus | Domidoor',
      desc: 'Termopane cu montaj inclus în Timișoara, Ghiroda, Giroc, Dumbrăvița. Preț de producător, măsurători gratuite, garanție 10 ani. 0766 330 933.',
    },
    en: {
      title: 'PVC Windows Timișoara — Salamander Installation | Domidoor',
      desc: 'Salamander PVC window and door installation in Timișoara, Ghiroda, Giroc, Dumbrăvița and nearby villages. Free measuring, clean one-day installation, 10-year warranty. +40 766 330 933.',
    },
    de: {
      title: 'PVC-Fenster Timișoara — Salamander Montage | Domidoor',
      desc: 'Montage von Salamander PVC-Fenstern und -Türen in Timișoara, Ghiroda, Giroc, Dumbrăvița und Umgebung. Kostenloses Aufmaß, Montage an einem Tag, 10 Jahre Garantie. +40 766 330 933.',
    },
    es: {
      title: 'Ventanas PVC Timișoara — Montaje Salamander | Domidoor',
      desc: 'Montaje de ventanas y puertas PVC Salamander en Timișoara, Ghiroda, Giroc, Dumbrăvița y pueblos cercanos. Medición gratuita, montaje en un día, 10 años de garantía. +40 766 330 933.',
    },
    it: {
      title: 'Infissi PVC Timișoara — Montaggio Salamander | Domidoor',
      desc: 'Montaggio finestre e porte PVC Salamander a Timișoara, Ghiroda, Giroc, Dumbrăvița e paesi vicini. Rilievo gratuito, montaggio in un giorno, garanzia 10 anni. +40 766 330 933.',
    },
  },
  rulouriTimisoara: {
    path: '/rulouri-timisoara',
    ro: {
      title: 'Rulouri Exterioare Timișoara — Montaj, Somfy | Domidoor',
      desc: 'Rulouri exterioare din aluminiu în Timișoara, Ghiroda, Giroc, Dumbrăvița. Sisteme aplicate, tencuibile, suprapuse. Motoare Somfy. 0766 330 933.',
    },
    en: {
      title: 'Exterior Shutters Timișoara — Installation, Somfy Motors | Domidoor',
      desc: 'Exterior aluminium shutter installation in Timișoara, Ghiroda, Giroc, Dumbrăvița and nearby villages. Top-mounted, built-in, adaptive systems. Somfy motors, RAL colours. Free measuring: +40 766 330 933.',
    },
    de: {
      title: 'Rollläden Timișoara — Montage, Somfy-Motoren | Domidoor',
      desc: 'Montage von Aluminium-Außenrollläden in Timișoara, Ghiroda, Giroc, Dumbrăvița und Umgebung. Vorsatz-, Unterputz-, Aufsatzsysteme. Somfy-Motoren, RAL-Farben. Kostenloses Aufmaß: +40 766 330 933.',
    },
    es: {
      title: 'Persianas Timișoara — Montaje, Motores Somfy | Domidoor',
      desc: 'Montaje de persianas exteriores de aluminio en Timișoara, Ghiroda, Giroc, Dumbrăvița y pueblos cercanos. Sistemas aplicados, enlucibles, superpuestos. Motores Somfy, colores RAL. Medición gratuita: +40 766 330 933.',
    },
    it: {
      title: 'Avvolgibili Timișoara — Montaggio, Motori Somfy | Domidoor',
      desc: 'Montaggio avvolgibili esterne in alluminio a Timișoara, Ghiroda, Giroc, Dumbrăvița e paesi vicini. Sistemi applicati, a scomparsa, sovrapposti. Motori Somfy, colori RAL. Rilievo gratuito: +40 766 330 933.',
    },
  },
  rulouriArad: {
    path: '/rulouri-arad',
    ro: {
      title: 'Rulouri Exterioare Arad — Montaj, Somfy | Domidoor',
      desc: 'Rulouri exterioare din aluminiu în Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Sisteme aplicate, tencuibile, suprapuse. Motoare Somfy. 0766 330 933.',
    },
    en: {
      title: 'Exterior Shutters Arad — Installation, Somfy Motors | Domidoor',
      desc: 'Exterior aluminium shutter installation in Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Top-mounted, built-in, adaptive systems. Somfy motors, RAL colours. Free measuring: +40 766 330 933.',
    },
    de: {
      title: 'Rollläden Arad — Montage, Somfy-Motoren | Domidoor',
      desc: 'Montage von Aluminium-Außenrollläden in Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Vorsatz-, Unterputz-, Aufsatzsysteme. Somfy-Motoren, RAL-Farben. Kostenloses Aufmaß: +40 766 330 933.',
    },
    es: {
      title: 'Persianas Arad — Montaje, Motores Somfy | Domidoor',
      desc: 'Montaje de persianas exteriores de aluminio en Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Sistemas aplicados, enlucibles, superpuestos. Motores Somfy, colores RAL. Medición gratuita: +40 766 330 933.',
    },
    it: {
      title: 'Avvolgibili Arad — Montaggio, Motori Somfy | Domidoor',
      desc: 'Montaggio avvolgibili esterne in alluminio ad Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Sistemi applicati, a scomparsa, sovrapposti. Motori Somfy, colori RAL. Rilievo gratuito: +40 766 330 933.',
    },
  },

  garajArad: {
    path: '/porti-de-garaj-arad',
    ro: {
      title: 'Uși de Garaj Arad — Montaj Porți Secționale | Domidoor',
      desc: 'Montaj uși de garaj secționale (porți) în Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Măsurători gratuite, garanție 10 ani. Tel: 0766 330 933.',
    },
    en: {
      title: 'Garage Doors Arad — Sectional & Roller Installation | Domidoor',
      desc: 'Sectional and roller garage door installation in Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Free measuring, one-day installation, 10-year warranty. Call +40 766 330 933.',
    },
    de: {
      title: 'Garagentore Arad — Sektional- & Rolltor-Montage | Domidoor',
      desc: 'Montage von Sektional- und Rolltoren in Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Kostenloses Aufmaß, Montage an einem Tag, 10 Jahre Garantie. +40 766 330 933.',
    },
    es: {
      title: 'Puertas de Garaje Arad — Montaje Seccionales | Domidoor',
      desc: 'Montaje de puertas seccionales y enrollables en Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Medición gratuita, montaje en un día, 10 años de garantía. +40 766 330 933.',
    },
    it: {
      title: 'Porte da Garage Arad — Montaggio Sezionali | Domidoor',
      desc: 'Montaggio portoni sezionali e avvolgibili ad Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Rilievo gratuito, montaggio in un giorno, garanzia 10 anni. +40 766 330 933.',
    },
  },
  pvcArad: {
    path: '/tamplarie-pvc-arad',
    ro: {
      title: 'Termopane Arad cu Montaj Inclus | Domidoor',
      desc: 'Termopane cu montaj inclus în Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Preț de producător, măsurători gratuite, garanție 10 ani. 0766 330 933.',
    },
    en: {
      title: 'PVC Windows Arad — Salamander Installation | Domidoor',
      desc: 'Salamander PVC window and door installation in Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Free measuring, clean one-day installation, 10-year warranty. +40 766 330 933.',
    },
    de: {
      title: 'PVC-Fenster Arad — Salamander Montage | Domidoor',
      desc: 'Montage von Salamander PVC-Fenstern und -Türen in Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Kostenloses Aufmaß, Montage an einem Tag, 10 Jahre Garantie. +40 766 330 933.',
    },
    es: {
      title: 'Ventanas PVC Arad — Montaje Salamander | Domidoor',
      desc: 'Montaje de ventanas y puertas PVC Salamander en Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Medición gratuita, montaje en un día, 10 años de garantía. +40 766 330 933.',
    },
    it: {
      title: 'Infissi PVC Arad — Montaggio Salamander | Domidoor',
      desc: 'Montaggio finestre e porte PVC Salamander ad Arad, Ineu, Chișineu-Criș, Curtici, Lipova. Rilievo gratuito, montaggio in un giorno, garanzia 10 anni. +40 766 330 933.',
    },
  },
  admin: {
    path: '/admin',
    noindex: true,
    ro: { title: 'Domidoor Admin', desc: '' },
  },
};
;
